import { render, staticRenderFns } from "./GraphicsLoader.vue?vue&type=template&id=0bbf11ee&scoped=true&"
import script from "./GraphicsLoader.vue?vue&type=script&lang=js&"
export * from "./GraphicsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf11ee",
  null
  
)

export default component.exports